import { defineStore } from "pinia";
import { showError } from "src/utils/notify";

export const useCompleteDeals = defineStore("completeDeals", {
  state: () => ({
    completeDealList: [],
    loadCompleteDeals: false,
  }),
  getters: {},
  actions: {
    async getCompleteDealsData(params) {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.COMPLETE_DEALS(params.page, params.per_page)
        );
        if (params.page && params.page == 1) {
          this.loadCompleteDeals = false;
          this.completeDealList = [];
        }
        if (response.data) {
          Array.prototype.push.apply(
            this.completeDealList,
            response.data.items
          );
          this.loadCompleteDeals = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetCompleteDealsData() {
      this.completeDealList = [];
      this.loadCompleteDeals = false;
    },
  },
});
